import { useSearchParams } from "react-router-dom";
import { PageHeader } from "@/components/Badges";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { FoodCostCalc } from "@/components/calc/FoodCostCalc";
import { PricingCalc } from "@/components/calc/PricingCalc";
import { MenuEngineering } from "@/components/calc/MenuEngineering";
import { KpiDashboard } from "@/components/calc/KpiDashboard";
import { t } from "@/lib/i18n";

export default function CalculatorsPage() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "foodcost";
  return (
    <div data-testid="calculators-page">
      <PageHeader eyebrow={t("Core Economic Engine · strumenti decisionali")} title={t("Calcolatori operativi")}
        subtitle={t("Food cost preventivo e consuntivo, pricing, menu engineering e KPI. I dati salvati alimentano il Cockpit e la discussione del team.")} />
      <div className="px-5 lg:px-8 py-6">
        <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })}>
          <TabsList className="bg-card border border-border h-auto p-1 flex-wrap">
            <TabsTrigger data-testid="tab-foodcost" value="foodcost">{t("Food Cost")}</TabsTrigger>
            <TabsTrigger data-testid="tab-pricing" value="pricing">{t("Pricing")}</TabsTrigger>
            <TabsTrigger data-testid="tab-menu" value="menu">{t("Menu Engineering")}</TabsTrigger>
            <TabsTrigger data-testid="tab-kpi" value="kpi">{t("KPI")}</TabsTrigger>
          </TabsList>
          <TabsContent value="foodcost" className="mt-6"><FoodCostCalc /></TabsContent>
          <TabsContent value="pricing" className="mt-6"><PricingCalc /></TabsContent>
          <TabsContent value="menu" className="mt-6"><MenuEngineering /></TabsContent>
          <TabsContent value="kpi" className="mt-6"><KpiDashboard /></TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
